import {
  createAds,
  getAds,
  getAllAds,
  updateAds,
  deleteAds,
  assignAdsVideo,
  getAdsVideo,
} from '../../api/ads'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Cookies } from 'react-cookie'
import toast from 'react-hot-toast'

// const isDev = process.env.NODE_ENV === 'development'

const initialState = {
  loading: false,
  error: null,
  adsList: [],
  ads: null,
  videoAds: [],
}
export const assignAdsVideoReq = createAsyncThunk(
  'assignAdsVideo',
  async (data, { rejectWithValue }) => {
    const { id, ads_ids } = data
    try {
      const res = await assignAdsVideo(id, { ads_ids })
      return res
    } catch (err) {
      toast.error(err.response.data.message)
      return rejectWithValue({ err: err.response.data })
    }
  },
)
export const getAdsVideoReq = createAsyncThunk('getAdsVideo', async (data, { rejectWithValue }) => {
  try {
    const res = await getAdsVideo(data.id)
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})
export const createAdsReq = createAsyncThunk('createAds', async (data, { rejectWithValue }) => {
  const {
    title,
    type,
    start_time,
    duration,
    text,
    text_color,
    text_background_color,
    link,
    formData,
  } = data
  let createData
  if (type === 'text') {
    createData = {
      title,
      type,
      start_time,
      duration,
      text,
      text_color,
      text_background_color,
      link,
    }
  } else {
    createData = {
      title,
      type,
      start_time,
      duration,
      image: formData,
      link,
    }
  }
  try {
    const res = await createAds(createData, type)
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})
export const updateAdsReq = createAsyncThunk('updateAds', async (data, { rejectWithValue }) => {
  const {
    id,
    title,
    type,
    start_time,
    duration,
    text,
    text_color,
    text_background_color,
    link,
    formData,
  } = data
  let updateData
  if (type === 'text') {
    updateData = {
      title,
      type,
      start_time,
      duration,
      text,
      text_color,
      text_background_color,
      link,
    }
  } else {
    updateData = {
      title,
      type,
      start_time,
      duration,
      image: formData,
      link,
    }
  }
  try {
    const res = await updateAds(data.id, updateData, type)
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})
export const getAllAdsReq = createAsyncThunk('getAllAds', async (data, { rejectWithValue }) => {
  try {
    const res = await getAllAds()
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})

export const getAdsReq = createAsyncThunk('getAds', async (data, { rejectWithValue }) => {
  try {
    const res = await getAds(data.id)
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})
export const deleteAdsReq = createAsyncThunk('deleteAds', async (data, { rejectWithValue }) => {
  try {
    const res = await deleteAds(data.id)
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})

export const AdsSlice = createSlice({
  name: 'ads',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllAdsReq.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(getAllAdsReq.fulfilled, (state, action) => {
        state.loading = false
        state.adsList = action.payload
      })
      .addCase(getAllAdsReq.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(getAdsVideoReq.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(getAdsVideoReq.fulfilled, (state, action) => {
        state.loading = false
        state.videoAds = action.payload
      })
      .addCase(getAdsVideoReq.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(assignAdsVideoReq.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(assignAdsVideoReq.fulfilled, (state, action) => {
        state.loading = false
        // state.videoAds = [...state.videoAds, action.payload]
      })
      .addCase(assignAdsVideoReq.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(getAdsReq.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(getAdsReq.fulfilled, (state, action) => {
        state.loading = false
        state.ads = action.payload
      })
      .addCase(getAdsReq.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(updateAdsReq.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateAdsReq.fulfilled, (state, action) => {
        state.loading = false
        const index = state.adsList.findIndex((obj) => obj.id === action.payload.id)

        if (index !== -1) {
          state.adsList[index] = action.payload
        }
      })
      .addCase(updateAdsReq.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(createAdsReq.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(createAdsReq.fulfilled, (state, action) => {
        state.loading = false
        state.adsList = [...state.adsList, action.payload]
      })
      .addCase(createAdsReq.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(deleteAdsReq.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(deleteAdsReq.fulfilled, (state, action) => {
        state.loading = false
        state.adsList = state.adsList.filter((obj) => obj.id !== action.payload.id)
      })
      .addCase(deleteAdsReq.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

// export const { } = AdsSlice.actions

export default AdsSlice.reducer
